import { Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";

const AuthLayout = ({ children, ...rest }) => {
  const isLogined = !!localStorage.getItem("accessToken");

  return isLogined ? (
    <Navigate exact to={`/`} />
  ) : (
    <>
      {children} <ToastContainer />
    </>
  );
};
export default AuthLayout;
